import styled from "styled-components";
import { colors } from "@/theme";

export const ReviewTransactionContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
`;

export const ReviewTransactionTitleContainer = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 16px;
`;

export const ReviewTransactionSubtitleContainer = styled.div`
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const TransactionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 16px 0;
`;

export const ShippingInstructionsContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  row-gap: 24px;
  width: 100%;
  border-right: 1px solid ${colors.fieldTextHelper};

  &:last-of-type {
    border-right: none;
  }
`;

export const ShippingInstructionsTitle = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ShippingInstructionsSubContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  row-gap: 20px;
`;

export const ShippingInstructionsSubtitle = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ShippingInstructionsValue = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 29px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const CardDataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  column-gap: 16px;
`;

export const CardData = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 29px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
